import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Category, CreateCategoryRequest } from '@financial/shared';
import { api } from '../../lib/api';
import { notify } from '../../store/notifications';

const KEY = ['categories'];

async function listCategories(): Promise<Category[]> {
  const res = await api.get<Category[]>('/categories');
  return res.data;
}

export function useCategories() {
  return useQuery({ queryKey: KEY, queryFn: listCategories });
}

export function useCreateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: CreateCategoryRequest) => {
      const res = await api.post<Category>('/categories', body);
      return res.data;
    },
    onSuccess: (category) => {
      void qc.invalidateQueries({ queryKey: KEY });
      notify.success('Categoría creada', {
        action: {
          label: 'Deshacer',
          onClick: async () => {
            await api.delete(`/categories/${category.id}`);
            void qc.invalidateQueries({ queryKey: KEY });
            notify.info('Categoría deshecha');
          },
        },
      });
    },
  });
}

export function useDeleteCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/categories/${id}`);
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: KEY }),
  });
}
